import React from 'react';
import CommitHeatmap from '../../components/CommitHeatmap/CommitHeatmap';

export default function ProjectActivityHeatmapSection({ orgId, streamId, projectId }: any) {
  return (
    <div className="mb-6">
      <CommitHeatmap
        scope="project"
        organisationId={orgId}
        streamId={streamId}
        projectId={projectId}
        title="Activity Heatmap"
      />
    </div>
  );
}
